export default __webpack_public_path__ + "static/media/Skype1.67acfed9.png";